import {
  Box,
  Typography,
  Button,
  Grid,
  FormControlLabel,
  Checkbox,
  Card,
  CardContent,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import BotBg from "assets/Icons/bot_bg_1.svg";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { startPrepaidAgent } from "utils/lambda";
import AgentBotServices from "services/bot";
import BotCheck from "assets/Icons/bot_check.svg";
import BotUnCheck from "assets/Icons/bot_uncheck.svg";
import BotProgress from "components/progressbar";
import BotStart from "assets/Icons/bot_start.svg";
import CommonTable from "components/commontable";
import BotLoader from "components/agent_bot/botLoader";
import BotGalaxy from "assets/Icons/bot_galaxy.svg";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import { io } from "socket.io-client";
import { ErrorToaster } from "components/Toaster";

const socket = io(process.env.REACT_APP_BASE_URL, {
  transports: ["websocket"],
  reconnection: true,
  reconnectionDelay: 2000,
  reconnectionAttempts: 10,
});

const PrepaidAiAgent = () => {
  const [started, setStarted] = useState("idle"); // idle | running | success | failed
  const [status, setStatus] = useState({
    job_id: null,
    bot_number: 1, // assume starting from bot 1
    status: "pending", // default status
    vin: null,
    invoice_no: null,
    totalCount: 0,
    failedCount: 0,
    percent: 0,
    message: "Getting and reading PDF invoice...",
  });
  const [selectedType, setSelectedType] = useState("");
  const [botsSummary, setBotsSummary] = useState({
    bot1: {},
    bot2: {},
  });

  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });
  const [loading, setLoading] = useState(false);
  const [jobId, setJobId] = useState(null);
  const [muted, setMuted] = useState(
    localStorage.getItem("bot_voice_muted") === "true"
  );

  const toggleMute = () => {
    const newState = !muted;
    setMuted(newState);

    // Stop any current speech immediately
    if (newState && window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }

    localStorage.setItem("bot_voice_muted", newState);
  };

  const columns = [
    { label: "Run Date", field: "updatedAt", type: "date" },
    { label: "VIN #", field: "vin" },
    { label: "Storage Fee", field: "storage" },
    { label: "Late Fee", field: "late_fee" },
    { label: "Status", field: "status" },
    { label: "Comment & Summary", field: "comment_summary" },
    { label: "Invoice#", field: "invoice_no" },
  ];
  const handleCheckboxChange = (type) => {
    setSelectedType((prevType) => (prevType === type ? "" : type));
  };
  const getStatus = async () => {
    try {
      const params = { table: selectedType };
      const response = await AgentBotServices.getPrepaidAgentStatus(params);

      if (response?.data?.result?.success) {
        const result = response.data.result;
        const latestRecord = result.latestRecord || {};
        const uniqueRecord = result.uniqueCounts || {};

        // Save everything you need for progress bars
        setStatus({
          job_id: result.job_id,
          bot_number: Number(result.bot_number || 0),
          status: result.status,
          vin: result.vin || null,
          invoice_no: latestRecord.invoice_no || result?.invoice_no || null,
          uniquevin: uniqueRecord?.vin || 0,
          percent: result.percent || 0,
          message: result.message || "",
        });
      }
    } catch (err) {
      console.error("❌ Polling failed:", err);
    }
  };

  // useEffect(() => {
  //   const handleConnect = () => {
  //     console.log("✅ Socket connected:", socket.id);
  //     if (selectedType) {
  //       console.log("🟢 Emitting get_status for:", selectedType);
  //       socket.emit("get_status", selectedType);
  //     }
  //   };

  //   const handleDisconnect = (reason) => {
  //     console.warn("⚠️ Socket disconnected:", reason);
  //   };

  //   const handleConnectError = (err) => {
  //     console.error("❌ Socket connect_error:", err.message);
  //   };

  //   socket.on("connect", handleConnect);
  //   socket.on("disconnect", handleDisconnect);
  //   socket.on("connect_error", handleConnectError);

  //   return () => {
  //     socket.off("connect", handleConnect);
  //     socket.off("disconnect", handleDisconnect);
  //     socket.off("connect_error", handleConnectError);
  //   };
  // }, [selectedType]);

  // useEffect(() => {
  //   if (!selectedType) return;

  //   const interval = setInterval(() => {
  //     socket.emit("get_status", selectedType);
  //   }, 10000);

  //   return () => clearInterval(interval);
  // }, [selectedType]);

  // useEffect(() => {
  //   const handleStatus = (data) => {
  //     if (!data || data.table !== selectedType) return;

  //     const result = data.result;
  //     if (result?.success) {
  //       const latestRecord = result.latestRecord || {};
  //       const uniqueRecord = result.uniqueCounts || {};

  //       setStatus({
  //         job_id: result.job_id,
  //         bot_number: Number(result.bot_number || 0),
  //         status: result.status,
  //         vin: result.vin || null,
  //         container_no: result.container_no || null,
  //         vendor: latestRecord.vendor_name || result?.vendor_name || null,
  //         invoice_no: latestRecord.invoice_no || result?.invoice_no || null,
  //         uniquevin: uniqueRecord?.vin || 0,
  //         uniquevendor: uniqueRecord?.vendor_name || 0,
  //         uniquecontainer: uniqueRecord?.container_no || 0,
  //         totalCount: result.total || 0,
  //         completedCount: result.completed || 0,
  //         failedCount: result.failed || 0,
  //         inProgressCount: result.in_progress || 0,
  //         partialCount: result.partialCount || 0,
  //         pendingCount: result.pendingCount || 0,
  //         percent: result.percent || 0,
  //         message: result.message || "",
  //       });
  //     } else if (data.error) {
  //       console.error("❌ Socket bot_status error:", data.message);
  //     }
  //   };

  //   socket.on("bot_status", handleStatus);

  //   // cleanup listener
  //   return () => {
  //     socket.off("bot_status", handleStatus);
  //   };
  // }, [selectedType]);

  const [buttonDisabled, setButtonDisabled] = useState(false);

  useEffect(() => {
    socket.on("progress_status_all", (data) => {
      if (!data?.results) return;

      const { shipping, towing, clearance } = data.results;

      const anyInProgress =
        shipping?.inProgress || towing?.inProgress || clearance?.inProgress;

      setButtonDisabled(anyInProgress);
    });

    return () => {
      socket.off("progress_status_all");
    };
  }, []);

  const getList = async (page = 1, job = null) => {
    setLoading(true);
    try {
      const params = {
        table: selectedType,
        page,
        limit: pagination.limit,
        job_id: job,
      };

      const response = await AgentBotServices.getPrepaidAgentList(params);
      if (response?.data?.result) {
        const result = response.data.result;

        // ✅ Update table data
        setData(result.data || []);

        // ✅ Fix: use pagination object from backend
        const p = result.pagination || {};
        setPagination({
          page: p.page || page,
          limit: p.limit || pagination.limit,
          total: p.total || 0,
          totalPages: p.totalPages || 1,
        });
      }
    } catch (err) {
      console.error("❌ Fetch failed:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (jobId) {
      setPagination({ page: 1, limit: 10, total: 0, totalPages: 1 });
      getList(1, jobId);
    }
  }, [selectedType, jobId]);

  const handlePageChange = (e, value) => {
    getList(value, jobId);
  };

  const handleStart = async () => {
    if (!selectedType || selectedType === "") {
      ErrorToaster("Please select type!");
      return;
    }
    setStarted("running");

    await new Promise((r) => setTimeout(r, 2000));

    const res = await startPrepaidAgent();

    let parsed = {};
    try {
      if (typeof res?.body === "string") parsed = JSON.parse(res.body);
      else if (res?.data?.body && typeof res.data.body === "string")
        parsed = JSON.parse(res.data.body);
      else parsed = res?.body || res?.data || {};
    } catch (e) {
      console.error("❌ Parse failed", e);
      parsed = {};
    }

    const bots = parsed?.summary || {};
    const job_id = parsed?.job_id || null;
    if (res?.statusCode === 200) {
      setStarted("success");
      setJobId(job_id);
      setBotsSummary(bots);

      if (bots?.bot1?.actionPerformed || bots?.bot2?.actionPerformed) {
        getList(1, job_id);
      }
    } else {
      console.error("❌ Failed to start", res);
      setStarted("failed");
    }
  };

  useEffect(() => {
    let interval;
    if (started === "running") {
      interval = setInterval(() => {
        getStatus();
      }, 10000); // poll every 10s
    }
    return () => clearInterval(interval);
  }, [started]);

  const startagain = () => {
    setStarted("idle");
    setSelectedType("");
    setData([]);
    setBotsSummary({
      bot1: { actionPerformed: false, duration: "0 min 0 sec" },
      bot2: {
        actionPerformed: false,
        duration: "0 min 0 sec",
      },
    });
    setStatus({
      job_id: null,
      bot_number: 1, // assume starting from bot 1
      status: "pending", // default status
      vin: null,
      failedCount: 0,
      inProgressCount: 0,
      percent: 0,
      message: "Getting and reading PDF invoice...",
    });
    setPagination({ page: 1, limit: 10, total: 0, totalPages: 1 });
    setJobId(null);
  };

  return (
    <>
      {started === "idle" ? (
        <>
          <Box
            sx={{
              width: "100%",
              minHeight: "100vh",
              backgroundImage: `url(${BotBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              color: "white",
            }}
          >
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", mb: 1, fontSize: "44px" }}
            >
              Hi! I Am <span style={{ color: "#56B711" }}>DocuSift</span>
            </Typography>

            <Typography
              sx={{
                fontFamily: "sans-serif",
                color: "#FFFFFF",
                mb: 3,
                fontWeight: "300 !important",
                fontSize: "40px",
              }}
            >
              Your Prepaid Charges Agent
            </Typography>
            <Box
              component="img"
              src={BotStart}
              alt="Bot"
              sx={{ width: "40%", height: "40%" }}
            />

            <Typography
              sx={{
                color: "#FFFFFF",
                fontWeight: 500,
                fontSize: "32px",
              }}
            >
              Please Select The Charges Type You Want Me To Process{" "}
            </Typography>

            {/* ✅ Custom Checkbox Icons (radio-like behavior) */}
            <Box sx={{ display: "flex", gap: 3, mb: 3 }}>
              {["Storage & Late Fee"].map((type) => (
                <FormControlLabel
                  key={type}
                  control={
                    <Checkbox
                      icon={<img src={BotUnCheck} alt="un_check" />}
                      checkedIcon={<img src={BotCheck} alt="checked" />}
                      checked={selectedType === type.toLowerCase()}
                      onChange={() => handleCheckboxChange(type.toLowerCase())}
                    />
                  }
                  label={type}
                />
              ))}
            </Box>

            {/* Start Button */}
            <Button
              onClick={handleStart}
              variant="contained"
              disabled={!selectedType || buttonDisabled} // disable until selection
              sx={{
                background: "linear-gradient(to right, #0C6135, #5BBC0F)",
                px: 4,
                py: 1,
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: "bold",
                "&:hover": {
                  background: "linear-gradient(to right, #0C6135, #5BBC0F)",
                },
              }}
            >
              Start Invoices Processing
            </Button>
          </Box>
        </>
      ) : started === "running" ? (
        <>
          <Box
            sx={{
              position: "relative",
              width: "100%",
              minHeight: "100vh",
              backgroundImage: `url(${BotBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              color: "white",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <img src={BotGalaxy} alt="logo" />
              <Typography sx={{ fontSize: "42px", fontWeight: 400 }}>
                <strong style={{ fontWeight: 600 }}>
                  {status?.bot_number === 1
                    ? "Agent DocuSift"
                    : status?.bot_number === 2
                    ? "Agent ChargeMaster"
                    : "Agent ChargeMaster"}
                </strong>{" "}
                -{" "}
                {status?.bot_number === 1
                  ? "Invoice Processor"
                  : status?.bot_number === 2
                  ? "Storage & Late Fee Executer"
                  : "Storage & Late Fee Executer"}
              </Typography>
            </Box>
            <BotLoader botStatus={status} muted={muted} prepaid={true} />
            <BotProgress botStatus={status} prepaid={true} />
            <div
              onClick={toggleMute}
              style={{
                position: "absolute",
                top: 70,
                right: 20,
                background: "#4ab43e",
                borderRadius: "50%",
                padding: "8px",
                cursor: "pointer",
                zIndex: 10,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              }}
            >
              {muted ? (
                <VolumeOffIcon style={{ fontSize: 24 }} />
              ) : (
                <VolumeUpIcon style={{ fontSize: 24 }} />
              )}
            </div>
          </Box>
        </>
      ) : (
        <>
          <Box
            sx={{
              width: "100%",
              minHeight: "100vh",
              backgroundImage: `url(${BotBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              color: "white",
              p: 4,
              pt: 12,
            }}
          >
            {/* === Header === */}
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    p: 0,
                    m: 0,
                    textAlign: "start",
                    fontSize: "32px",
                  }}
                >
                  Galaxy Ai - Prepaid Charges Assistant
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} textAlign="right">
                <Button
                  onClick={startagain}
                  variant="contained"
                  sx={{
                    background: "linear-gradient(to right, #0C6135, #5BBC0F)",
                    px: 4,
                    py: 1,
                    borderRadius: "8px",
                    textTransform: "none",
                    fontWeight: "bold",
                    "&:hover": {
                      background: "linear-gradient(to right, #0C6135, #5BBC0F)",
                    },
                  }}
                >
                  Start Again
                </Button>
              </Grid>
            </Grid>

            {/* === Table Section === */}
            <CommonTable
              // title="Clearance Data"
              columns={columns}
              rows={data}
              pagination={pagination}
              loading={loading}
              onPageChange={handlePageChange}
              prepaid={true}
            />
          </Box>
        </>
      )}
    </>
  );
};

export default PrepaidAiAgent;

const SummaryCard = ({ title, points, img, desc, color, performed }) => (
  <Card
    sx={{
      background: "none",
      borderRadius: 3,
      p: 2,
      color: "white",
      minHeight: "580px",
      border: `1px solid ${color}`,
    }}
  >
    <CardContent>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
        {img}
        <Box sx={{ textAlign: "start" }}>
          <Typography sx={{ fontWeight: "bold", fontSize: "22px" }}>
            {title}
          </Typography>
          <Typography sx={{ fontWeight: 400, fontSize: "14px", mb: 1 }}>
            Job Completion: <strong>{desc}</strong>
          </Typography>
        </Box>
      </Box>

      {(typeof points === "function" ? points() : points)?.map((p, i) => {
        const txt = String(p).toLowerCase();

        // 🎯 Color rules
        const isPrev = txt.startsWith("previous:");
        const isNew = txt.startsWith("new:");
        const isTow = txt.startsWith("processed towing:");
        const isShip = txt.startsWith("processed shipping:");

        return (
          <Box key={i} sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            <CheckCircleIcon
              sx={{
                color: performed ? "#5BBC0F" : "#888",
                fontSize: 18,
              }}
            />

            <Typography sx={{ fontSize: "18px", textAlign: "start" }}>
              {String(p)
                .split(/(\d+)/)
                .map((part, idx) => {
                  if (!/^\d+$/.test(part)) return <span key={idx}>{part}</span>;

                  // ✅ Apply correct color
                  let color = "#5BBC0F"; // default green

                  if (isPrev || isNew) color = "#FFF500"; // yellow
                  else if (isTow || isShip) color = "#00E5FF"; // aqua pop

                  return (
                    <span
                      key={idx}
                      style={{
                        color,
                        fontWeight: "bold",
                      }}
                    >
                      {part}
                    </span>
                  );
                })}
            </Typography>
          </Box>
        );
      })}
    </CardContent>
  </Card>
);
